<template>
    <modal
        class="new-editor-modal"
        name="new-editor-modal"
        @before-open="handleBeforeOpen"
        @before-close="isLoaded=false"
        transition="fade"
        :adaptive="true"
        :scrollable="true"
        :reset="true"
        width="60%"
        height="80%"
        style="z-index: 2011;"
    >
        <div id="modal-header">
            <div class="w-75 d-flex">
                <p>{{ editorTitle }}</p>
            </div>
            <button  v-if="!signLoading" type="button"
                    class="close position-absolute"
                    style="right: 1.25rem; top: 25%"
                    @click="()=>{$modal.hide('new-editor-modal');isLoaded=false}"
                    aria-label="Close"
            >
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1.64102L14.859 0L8.49997 6.359L2.14102 4.62582e-05L0.5 1.64107L6.85895 8.00002L0.500034 14.3589L2.14105 16L8.49997 9.64104L14.8589 16L16.5 14.359L10.141 8.00002L16.5 1.64102Z" fill="#ABAEB8"/>
                </svg>
            </button>
        </div>
        <div id="modal-body">
            <component
                @closeAfterSave="()=>{$modal.hide('new-editor-modal');isLoaded=false}"
                @validPhone="handleValidPhone"
                @timeEnded="timeEnded"
                @handleIsFullySigned="handleIsFullySigned"
                ref="file"
                :tender="tender"
                :order="order"
                :handleLoaded="handleLoaded"
                :is-editable="isEditable"
                :is="currentFile"
                :lng="lng"
            />
        </div>
        <div id="modal-footer">
          <template v-if="!signLoading">
            <template v-if="isFullySigned">
              <button aria-expanded="false" :disabled="isLoading || isLoaded === false" @click="downloadPDF" type="button" class="btn btn-primary">
                <svg class="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.23096 9.01613V0.5H8.67326V9.01613L11.3656 6.30645L12.4233 7.37097L8.96173 10.7581L7.90403 11.8226L6.9425 10.7581L3.48096 7.37097L4.53865 6.30645L7.23096 9.01613ZM13.9615 13.9516V11.9193H15.5V13.758C15.5 14.7258 14.7308 15.5 13.7692 15.5H2.23077C1.26923 15.5 0.5 14.7258 0.5 13.758V11.9193H2.03846V13.9516H13.9615Z" fill="#F0F7FF"/>
                </svg>
                <span>Բեռնել</span>
                <span v-if="isLoading" class="ml-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>
            </template>
          <template v-else-if="(openedBy === 'buyer' || openedBy === 'seller')">
            <template v-if="signStep">
              <button
                  @click="handleConfirmSign"
                  :disabled="hasInvalidPhone || signRequestLoading"
                  type="button"
                  class="btn btn-primary"
                  aria-expanded="false"
              >
                <i class="fa-solid fa-check mr-2"></i>
                <span>Հաստատել</span>
              </button>
            </template>
            <template v-else>
              <button
                  :disabled="isLoading || isLoaded === false"
                  @click="handleSign"
                  type="button"
                  class="btn btn-primary"
              >
                <span>Ստորագրել eSim-ով</span>
              </button>
            </template>
          </template>
          <button aria-expanded="false" :disabled="isLoading || isLoaded === false" @click="downloadPDF" type="button" class="btn btn-primary ml-2">
            <svg class="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.23096 9.01613V0.5H8.67326V9.01613L11.3656 6.30645L12.4233 7.37097L8.96173 10.7581L7.90403 11.8226L6.9425 10.7581L3.48096 7.37097L4.53865 6.30645L7.23096 9.01613ZM13.9615 13.9516V11.9193H15.5V13.758C15.5 14.7258 14.7308 15.5 13.7692 15.5H2.23077C1.26923 15.5 0.5 14.7258 0.5 13.758V11.9193H2.03846V13.9516H13.9615Z" fill="#F0F7FF"/>
            </svg>
            <span>Բեռնել և ստոր․ ID քարտով</span>
            <span v-if="isLoading" class="ml-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </button>
        </template>
        </div>
    </modal>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import Editor from '@tinymce/tinymce-vue'
import download from '@/mixins/download'
import init from '@/mixins/variables'

export default {
    name: 'NewEditorModal',
    mixins: [download, init],
    props: ['tender', 'contractHtml', 'order', 'openedBy'],
    components: {
        VueHtml2pdf,
        editor: Editor,
        contract_draft: () => import('./contract_draft'),
        contract_sign: () => import('./contract_sign'),
        contract_sign_loading: () => import('./contract_sign_loading'),
    },
    computed: {
      me() {
        return this.$store.getters['user/me']
      },
    },
    data() {
        return {
            details: {
                contract_pages_count: 5,
                allowed_days: '',
                warranty_period: '',
                respond_period: '',
            },
            hasInvalidPhone: true,
            isFullySigned: false,
            signRequestLoading: false,
            signed: false,
            signStep: false,
            signLoading: false,
            is_get_details: false,
            content: '',
            isLoading: false,
            editorContent: '',
            action: '',
            currentFile: '',
            lng: '',
            editorTitle: '',
            isLoaded: false,
            participantGroup: '',
            isEditable: false,
        }
    },
    methods: {
        handleLoaded() {
            if(!this.isLoaded){
                setTimeout(() => {
                    this.isLoaded = true;
                    if(this.contractHtml){
                      this.content = this.contractHtml;
                    } else {
                      this.content = this.$refs.file.$el.innerHTML
                    }
                }, 1000);
            }
        },
        handleValidPhone(invalid){
          console.log('>>>.', invalid);
          this.hasInvalidPhone = invalid
        },
        timeEnded(){
          this.currentFile = 'contract_sign';
          this.signLoading = false;
        },
        handleIsFullySigned(){
          this.isFullySigned = true;
        },
        handleBeforeOpen({
            params: {
                action = 'save',
                fileName,
                isEditable,
                lng = 'hy',
                editorTitle,
                participantGroup
            },
        }) {
            this.hasInvalidPhone = true;
            this.isFullySigned = false;
            this.isLoading = false;
            this.signed = false;
            this.signStep = false;
            this.signLoading = false;
            this.action = action
            this.currentFile = fileName
            this.participantGroup = participantGroup
            this.isEditable = Boolean(isEditable)
            this.lng = lng
            this.editorTitle = editorTitle
            if(this.action === 'download'){
                this.is_get_details = true;
            }
        },
        async handleSign() {
          this.signStep = true;
          this.currentFile = 'contract_sign';
        },
        async handleConfirmSign() {
          this.signRequestLoading = true;
          await this.handleSignRequest(this.$refs.file.phoneNumber);
        },
        async downloadPDF() {
            this.isLoading = true;
            console.log('this.content', this.content)
            await this.sendToPDFGeneration(this, this.content, this.editorTitle, () => {this.isLoading = false})
            await this.$emit('handleDownloadContract');
        },
        async generateFileHash (documentContent) {
          const encoder = new TextEncoder();
          const data = encoder.encode(documentContent);

          const hashBuffer = await crypto.subtle.digest('SHA-256', data);
          const hashArray = Array.from(new Uint8Array(hashBuffer));

          return btoa(String.fromCharCode.apply(null, hashArray));
        },
      async handleCheckSignRequest(apTransId, msspTransId) {
        const intervalDuration = 3000; // 3 seconds
        const maxDuration = 120000; // 120 seconds (2 minutes)
        const startTime = Date.now();

        const intervalId = setInterval(async () => {
          try {
            const response = await this.$client.post('/check-sign-document', {
              apTransId: apTransId, // User's phone number
              msspTransId: msspTransId, // Hash of the document
            });

            console.log(response);

            // Add a condition to stop the interval if the response indicates success
            if (response.data.status === 'ok' || response.data.status === 'SIGNATURE') {
              clearInterval(intervalId);
              console.log('DATA >>> ', response.data.data);
              const signedDocument = response.data.data.signed_document.Base64Signature || response.data.data.signed_document;
              console.log('signedDocument >>> ', signedDocument);
              this.$emit('handleGetContract', this.content, signedDocument);
              this.$notify({
                group: 'foo',
                type: 'success',
                text: 'Ստորագրումն ավարտվեց հաջողությամբ',
              });
            }
          } catch (error) {
            console.error(error);
            this.$notify({
              group: 'foo',
              type: 'error',
              text: 'Սխալ տեղի ունեցավ ստորագրման գործընթացում',
            });
            clearInterval(intervalId); // Stop further requests on error
          }

          // Stop the interval if the maximum duration is exceeded
          if (Date.now() - startTime >= maxDuration) {
            clearInterval(intervalId);
            this.timeEnded();
            this.$notify({
              group: 'foo',
              type: 'error',
              text: 'Ստորագրման գործընթացը ձախողվեց՝ ժամանակի ավարտի պատճառով',
            });
          }
        }, intervalDuration);
      },

      async handleSignRequest(phoneNumber) {
          const fileHash = await this.generateFileHash(this.contractHtml);

          const formattedPhoneNumber = `374${phoneNumber.replace(/\s+/g, '').trim().replace(/^0/, '')}`;

          console.log('formattedPhoneNumber', formattedPhoneNumber)
          try {
            const response = await this.$client.post('/sign-document', {
              phone_number: formattedPhoneNumber, // User's phone number
              file_hash: fileHash, // Hash of the document
            });
            console.log(response);
            console.log(response.data);
            console.log(response.data.status);
            console.log(response.data.status === 'ok');
            if (response.data.status === 'ok') {
              const data = response.data.data;
              this.signLoading = true;
              this.currentFile = 'contract_sign_loading';
              this.signRequestLoading = false;
              await this.handleCheckSignRequest(data.transaction_id || data.apTransId, data.mssp_transid || data.msspTransId)
            } else {
              this.signRequestLoading = false;
              this.$notify({
                group: 'foo',
                type: 'error',
                text: 'Սխալ տեղի ունեցավ ստորագրման գործընթացում'
              });
            }
          } catch (error) {
            console.error(error);
            this.$notify({
              group: 'foo',
              type: 'error',
              text: 'Սխալ տեղի ունեցավ ստորագրման գործընթացում'
            });
          }
        },
        consoleLog(element){
            console.log(element)
        },
    },
}
</script>
<style>
.table-1 {
    page-break-inside: avoid;
}
.table-1 {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    page-break-inside: avoid;
}
.table-1{
    border: 1px solid  black;
    border-collapse: collapse;
    margin: 20px auto;
    padding-bottom: 50px;
    text-align: center;
}
.table-1 tr th{
    border: 1px solid  black;
    border-collapse: collapse;
    font-size: 12px;
    padding: 8px 18px;
}
.table-1 tr td{
    border: 1px solid  black;
    border-collapse: collapse;
    text-align: center;
    padding: 7px 7px;
    font-size: 14px;
}
.editor-input {
    text-align:center;
    border: none;
    border-bottom: 2px solid rgb(80, 110, 228);
    width: 50px;
    height: 20px;
    outline: none;
    margin: 0;
    -webkit-appearance: none;
    -moz-appearance: textfield;
}
</style>
<style>
    .tab {
        margin-left: 25px;
    }
</style>
<style scoped>
    .big-table td{
        font-size: 8px !important;
        padding: 5px !important;
    }
    .big-table th{
        font-size: 10px !important;
        padding: 5px !important;
    }
    .info-block p:first-child{
        display: inline !important;
    }
    table { page-break-inside:auto }
    table{
        border: 1px solid  black !important;
        border-collapse: collapse !important;
        padding-bottom: 50px !important;
        text-align: center !important;
    }
    table tr th{
        border: 1px solid  black;
        border-collapse: collapse !important;
        font-size: 12px !important;
    }
    table tr td{
        border: 1px solid  black;
        border-collapse: collapse !important;
        text-align: center !important;
        font-size: 10px !important;
    }
    .full-row { page-break-inside:avoid; page-break-after:auto }
    .info-block{
      page-break-inside:avoid;
      page-break-after:auto;
      padding-top: 20px;
      box-sizing: border-box;
    }
    .info-block > tr {
      margin-top: 50px;
    }
    @media (max-width: 768px) {
        .new-editor-modal /deep/ .vm--modal {
        height: 90% !important;
        margin: auto 20px;
        width: auto !important;
        top: 0 !important;
        bottom: 0 !important;
        right: 0 !important;
        left: 0 !important;
        position: absolute;
        }
        .new-editor-modal /deep/ .vm--modal #modal-body{
        padding: 16px 8px 8px;
        }
    }
</style>
